import { render, staticRenderFns } from "./SuperAdminProfile.vue?vue&type=template&id=5f67362c&"
import script from "./SuperAdminProfile.vue?vue&type=script&lang=ts&"
export * from "./SuperAdminProfile.vue?vue&type=script&lang=ts&"
import style0 from "./SuperAdminProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports